// extracted by mini-css-extract-plugin
module.exports = {"textarea":"index_textarea__2Ix5R"};